import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function BarChart() {
    const value1 = 50;
    const value2 = 15;
    const value3 = 35;

    const data1 = {
        labels: ['self'],
        datasets: [{
            data: [value1, 100 - value1],
            backgroundColor: ['#FD7401', '#EDEFFE'],
            borderWidth: 0,
            barThickness: 15,
            maxBarThickness: 15,
        }],
    };
    const data2 = {
        labels: ['manager'],
        datasets: [{
            data: [value2, 50 - value2],
            backgroundColor: ['#DF2331', '#EDEFFE'],
            borderWidth: 0,
            barThickness: 15,
            maxBarThickness: 15,
        }],
    };
    const data3 = {
        labels: ['peers'],
        datasets: [{
            data: [value3, 50 - value3],
            backgroundColor: ['#9A258D', '#EDEFFE'],
            borderWidth: 0,
            barThickness: 15,
            maxBarThickness: 15,
        }],
    };

    const options = {
        padding: "0px",
        responsive: true,
        // maintainAspectRatio: true,
        // width: "50",
        // height: "50",
        indexAxis: 'y',
        scales: {
            x: {
                display: false,
                beginAtZero: true,
                max: 50,
            },
            y: {
                display: false,

            },
        },

        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        layout: {
            padding: {
                left: 50,
                right: 20,
                top: 0,
                bottom: 10,
            },
        },
    };

    return (

        <>
            <div className='mt-0' style={{ width: '200px', height: '50px' }}>

                <div className='d-flex align-items-center '>
                    <h5 className='me-5'>Self</h5>
                    <Bar data={data1} options={options} />
                    <span>{value1}</span>
                </div>
            </div>
            <div className='' style={{ width: '200px', height: '50px' }}>

                <div className='d-flex align-items-center'>
                    <h5 className=''>Manager</h5>
                    <Bar data={data2} options={options} />
                    <span>{value2}</span>
                </div>
            </div>
            <div className='' style={{ width: '200px', height: '50px' }}>

                <div className='d-flex align-items-center'>
                    <h5 className='me-4'>Peers</h5>
                    <Bar data={data3} options={options} />
                    <span>{value3}</span>
                </div>
            </div>



        </>
    );
}

export default BarChart;









